import validate from "/home/runner/work/driver-portal-frontend/driver-portal-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/middleware/auth.ts"),
  guest: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/middleware/guest.ts"),
  "insure-available": () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/middleware/insure-available.ts"),
  unverified: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/middleware/unverified.ts"),
  verified: () => import("/home/runner/work/driver-portal-frontend/driver-portal-frontend/middleware/verified.ts")
}